import { render } from "./index.vue?vue&type=template&id=8332dd58"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/trigger/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8332dd58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8332dd58', __exports__)) {
    api.reload('8332dd58', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=8332dd58", () => {
    api.rerender('8332dd58', render)
  })

}


export default __exports__